"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
const Document_1 = __importDefault(require("./Document"));
const Office_1 = __importDefault(require("./Office"));
const Resource_1 = __importDefault(require("../Resource"));
const class_transformer_1 = require("class-transformer");
const Deed_1 = __importDefault(require("./Deed"));
const DeedType_1 = __importDefault(require("./DeedType"));
class DocumentType extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.public_description = null;
        this.retention_days_before_expiry = null;
        this.archived_at = null;
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = DocumentType;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DocumentType.prototype, "uid", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DocumentType.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], DocumentType.prototype, "public_description", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createDocumentType", "updateDocumentType"] }),
    (0, class_validator_1.IsInt)({ groups: ["createDocumentType", "updateDocumentType"] }),
    (0, class_validator_1.Min)(1, { groups: ["createDocumentType", "updateDocumentType"] }),
    __metadata("design:type", Object)
], DocumentType.prototype, "retention_days_before_expiry", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)({ groups: ["createDocumentType", "updateDocumentType"] }),
    (0, class_validator_1.IsIn)(["CUSTOMER", "THIRD_PARTY", "SHARED_NOTARY", "OFFICE_NOTARY", "NONE"], {
        groups: ["createDocumentType", "updateDocumentType"],
    }),
    __metadata("design:type", Object)
], DocumentType.prototype, "default_document_request_recipient", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], DocumentType.prototype, "archived_at", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Office_1.default),
    __metadata("design:type", Office_1.default)
], DocumentType.prototype, "office", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], DocumentType.prototype, "created_at", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], DocumentType.prototype, "updated_at", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Document_1.default),
    __metadata("design:type", Array)
], DocumentType.prototype, "documents", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Deed_1.default),
    __metadata("design:type", Array)
], DocumentType.prototype, "deeds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DeedType_1.default),
    __metadata("design:type", Array)
], DocumentType.prototype, "deed_type", void 0);
